import type { ReactNode } from 'react';
import { AuthProvider } from '@/shared/auth/AuthProvider';
import { ToastProvider } from '@/shared/ui/toast/ToastProvider';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Composição dos providers globais em um único lugar.
 *
 * `ToastProvider` fica por fora: o `AuthProvider` não publica avisos, mas as
 * telas dentro dele publicam — e a ordem explícita evita a dúvida de "quem
 * envolve quem" quando um provider novo aparecer.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <ToastProvider>
      <AuthProvider>{children}</AuthProvider>
    </ToastProvider>
  );
}
